import type { Action } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';

import {
	confluenceLocalStorageInstance as localStorage,
	PERSISTED_KEYS_ON_SERVER,
} from '@confluence/storage-manager';

interface PremiumFeatureHighlightState {
	isEnabled: boolean;
}

const initialState: PremiumFeatureHighlightState = {
	// doing localStorage check in case it is undefined in testing.
	// localStorage can't be initialized in testing because this block of code is executed first
	isEnabled: localStorage
		? localStorage.getItem(PERSISTED_KEYS_ON_SERVER.PERSISTED_PREMIUM_FEATURE_HIGHLIGHT) === null ||
			localStorage.getItemAsBoolean(PERSISTED_KEYS_ON_SERVER.PERSISTED_PREMIUM_FEATURE_HIGHLIGHT)
		: true,
};

const actions = {
	update:
		(): Action<PremiumFeatureHighlightState> =>
		({ setState, getState }) => {
			const prevState = getState();
			const isEnabled = !prevState.isEnabled;
			setState({ isEnabled });
			localStorage?.setItem(
				PERSISTED_KEYS_ON_SERVER.PERSISTED_PREMIUM_FEATURE_HIGHLIGHT,
				isEnabled,
			);
		},
};

const store = createStore({
	initialState,
	actions,
	name: 'PremiumFeatureHighlightStore',
});

export const usePremiumFeatureHighlight = createHook(store);
